import React from 'react';
import _ from 'lodash';

import PetHOC from '../PetHOC';
import Bodies from './Bodies';
import Heads from './Heads';
import Eyes from './Eyes';
import Nose from './Nose';
import Feet from './Feet';
import Toy from '../../Goodies/Toy';

class Pig extends PetHOC {
	constructor(props) {
		super(props);
		this.actions = {
			idle: [
				{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: () => _.random(200, 4000),
					},
				},
				{
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: () => _.random(5000, 10000),
					},
				},
				{
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: () => _.random(200, 2500),
					},
					stop: {
						timeout: null,
						interval: () => 200,
					},
				},
				{
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: () => _.random(2000, 10000),
					},
					stop: {
						timeout: null,
						interval: () => 600,
					},
				},
				{
					name: 'sniff',
					actions: ['isSniffing'],
					start: {
						timeout: null,
						interval: () => _.random(150, 5000),
					},
					stop: {
						timeout: null,
						interval: () => 150,
					},
				},
				{
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: () => _.random(200, 4000),
					},
					stop: {
						timeout: null,
						interval: () => _.random(1000, 2000),
					},
				},
			],
			pet: [
				{
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: () => _.random(600, 1600),
					},
					stop: {
						timeout: null,
						interval: () => 600,
					},
				},
				{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => _.random(600, 1200),
					},
				},
				{
					name: 'stomp',
					actions: ['isStompingRight', 'isStompingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => 50,
					},
					stop: {
						timeout: null,
						interval: () => 100,
					},
				},
				{
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: () => _.random(200, 1000),
					},
					stop: {
						timeout: null,
						interval: () => _.random(200, 1000),
					},
				},
			],
		};
	}

	render() {
		return (
			<div className="pet-wrapper">
				<div
					className={this.getClassNames()}
					onMouseEnter={this.startBeingPet}
					onMouseLeave={this.stopBeingPet}>

					<img className="pet-frame" src={this.getFrameImagePathname()} alt="" />
					<div className="pet-name">{this.getName()}</div>
					<svg className="pet-shadow" viewBox="0 0 480 480">
						<ellipse cx="254" cy="366" rx="167" ry="33" />
					</svg>

					<div className="special-pet-transform-wrapper">
						<svg className="pet__body" viewBox="0 0 480 480">
							<Feet />
						</svg>
						<div className="pet-body-and-head">
							<svg className="pet__body" viewBox="0 0 480 480">
								<Bodies body={this.props.body} />
							</svg>
							<svg className="pet__head" viewBox="0 0 480 480">
								<Heads getHatTargetCoords={this.getHatTargetCoords} head={this.props.head} />
								<Eyes getGlassesTargetCoords={this.getGlassesTargetCoords} />
								{this.shouldRenderHat()}
							</svg>
						</div>
					</div>

					<div className="special-pet-transform-wrapper">
						<div className="pet-body-and-head">
							<svg className="pet__head" viewBox="0 0 480 480">
								<g className="pig-face">
									{this.shouldRenderGlasses()}
								</g>
								<Nose />
							</svg>
						</div>
					</div>

					<svg className="pet-toy" viewBox="0 0 480 480">
						<Toy toy={this.props.toy} />
					</svg>
				</div>
			</div>
		);
	}
}

export default Pig;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Pig/index.js